<template>
  <!-- A simple pop-over component using a Bootstrap theme. -->
  <VDropdown
    :triggers="$attrs.triggers || ['hover', 'focus']"
    theme="bs-popover"
    no-auto-focus
  >
    <slot name="reference"></slot>

    <template #popper>
      <div class="card popper-content">
        <div class="card-body">
          <h5 v-if="title" class="card-title">
            {{ title }}
          </h5>
          <div class="card-text">
            <slot></slot>
          </div>
        </div>
      </div>
    </template>
  </VDropdown>
</template>

<script>
export default {
  name: 'pop-over',

  props: {
    title: String
  }
};
</script>

<style lang="scss">
.v-popper--theme-bs-popover {
  &.v-popper__popper {
    z-index: 3000000;
  }

  .v-popper__inner {
    padding: 0;
  }

  .popper-content {
    max-width: 500px;
  }
}
</style>
